"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFileSize = void 0;
var formatFileSize = function formatFileSize(sizeInBytes) {
  var sizeInKiloBytes = sizeInBytes / 1024;
  if (sizeInKiloBytes < 1024) {
    return "".concat(sizeInKiloBytes.toFixed(2), " KB");
  }
  var sizeInMegaBites = sizeInKiloBytes / 1024;
  return "".concat(sizeInMegaBites.toFixed(2), " MB");
};
exports.formatFileSize = formatFileSize;